import React, { useContext, useState, useCallback } from 'react';

type EditModeContextType = {
    isInEditMode: boolean;
    isInChemGuardEditMode: boolean;
    toggleEditMode: () => void;
    toggleChemGuardEditMode: () => void;
    setEditMode: (enabled: boolean) => void;
    setChemGuardEditMode: (enabled: boolean) => void;
};

export const EditModeContext = React.createContext<EditModeContextType>(undefined!);

interface EditModeContextProviderProps {
    children: React.ReactNode;
}

export const EditModeContextProvider = ({ children }: EditModeContextProviderProps) => {
    const [isInEditMode, setIsInEditMode] = useState<boolean>(false);
    const [isInChemGuardEditMode, setIsInChemGuardEditMode] = useState<boolean>(false);

    const toggleEditMode = useCallback(() => {
        setIsInEditMode((prev) => !prev);
    }, []);

    const toggleChemGuardEditMode = useCallback(() => {
        setIsInChemGuardEditMode((prev) => !prev);
    }, []);

    const setEditMode = useCallback((enabled: boolean) => {
        setIsInEditMode(enabled);
    }, []);

    const setChemGuardEditMode = useCallback((enabled: boolean) => {
        setIsInChemGuardEditMode(enabled);
    }, []);

    return (
        <EditModeContext.Provider
            value={{
                isInEditMode,
                isInChemGuardEditMode,
                toggleEditMode,
                toggleChemGuardEditMode,
                setEditMode,
                setChemGuardEditMode,
            }}
        >
            {children}
        </EditModeContext.Provider>
    );
};

export const useEditMode = () => useContext(EditModeContext);
